// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3IIDE","footer":"ModalFilter_footer__1Jnpq"};